import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { Trans } from '@lingui/react/macro'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'
import { SignedDocumentTab } from './-tabs/signed'

export const Route = createFileRoute(
  '/_app/patienten/$id/_edit/_documents/unterschriftsdokumente/einwilligung-schweigepflicht',
)({
  component: RouteComponent,
  params: entityParams({ id: PatientId }),
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()

  return (
    <SignedDocumentTab
      id={patientId}
      findingIds={['FormsPatientConsentAndConfidentialityRequired']}
      type="PatientConsentAndConfidentiality"
      to="/patienten/$id/einwilligung-schweigepflicht/$form"
      title={<Trans>Einwilligungs- und Schweigepflichtserklärung</Trans>}
      createButtonText={<Trans>Einwilligungs- und Schweigepflichtserklärung erstellen</Trans>}
    />
  )
}
